import * as React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import './dialoge.css';
import { Chart } from 'react-google-charts';

export default function Dialogbox(props) {
  return (
    <>
      <Dialog id="create-popover" open={props !== null} onClose={props.onClose}>
        <Box
          sx={{
            height: '60vh',
            width: '85vh',
          }}
        >
          <div className="Dialog">
            <h3>{props?.dialog?.title}</h3>
            <CloseIcon onClick={props.onClose} sx={{ cursor: 'pointer' }} />
          </div>
          <Chart chartType="AreaChart" width="100%" height="90%" data={props.dialog.data} options={props.options} />
        </Box>
      </Dialog>
    </>
  );
}
